// extracted by mini-css-extract-plugin
export default {"statsContainer":"Stats_statsContainer__AYE99","tabs":"Stats_tabs__7ibqo","active":"Stats_active__K9kc8","content":"Stats_content__Aiemx"};